import { connect } from "react-redux";
import SegmentDetailIndex from "../../components/NewSegmentDetail/Index";

import {
  fetchSegmentSummary,
  clearSegmentSummary,
  getSegmentRulesCounts,
  requestActivation,
} from "../../actions/SegmentDetail";

import {
  loadAttributes,
  getAudienceCount,
} from "../../actions/SegmentCreation";
import {
  archiveSegment,
  getCreateCampaign,
  getSegmentList,
  getSegmentWithRules,
  rollbackRequestSuccessToFalse,
  selectedSegment,
} from "../../actions/SegmentList";
import { selectClient, getClientInfo } from "../../actions/App";
const mapStateToProps = state => {
  const {
    segment_summary,
    rules_count,
    request_activation_error,
    request_activation_success,
  } = state.segmentDetail;
  const {
    categories,
    value_typehead,
    audience_total_count,
  } = state.segmentCreation;
  const {
    selectedSegmentSetArray,
    segment_list_active,
    active_segment_attributes,
    recordActiveQueryParamsObj,
    create_campaign,
  } = state.segmentList;
  const { client_info, parent_client, roleId } = state.app;

  const { selected_client } = state.app;
  return {
    segment_summary,
    categories,
    client_info,
    parent_client,
    value_typehead,
    selectedSegmentSetArray,
    segment_list_active,
    active_segment_attributes,
    segment_active_creation: state.segmentCreation,
    selected_client,
    recordActiveQueryParamsObj,
    create_campaign,
    rules_count,
    audience_total_count,
    roleId,
    request_activation_error,
    request_activation_success,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSegmentSummary: id => {
      dispatch(fetchSegmentSummary(id));
    },
    loadAttributes: cid => {
      dispatch(loadAttributes(cid));
    },
    getSegmentWithRules: id => {
      dispatch(getSegmentWithRules(id));
    },
    selectClient: id => {
      dispatch(selectClient(id));
    },
    getClientInfo: id => {
      dispatch(getClientInfo(id));
    },
    clearSegmentSummary: () => {
      dispatch(clearSegmentSummary());
    },
    archiveSegment: id => {
      dispatch(archiveSegment(id));
    },
    getSegmentList: data => {
      dispatch(getSegmentList(data));
    },
    selectedSegment: setArray => {
      dispatch(selectedSegment(setArray));
    },
    getCreateCampaign: (id, data) => {
      dispatch(getCreateCampaign(id, data));
    },
    rollbackRequestSuccessToFalse: val =>
      dispatch(rollbackRequestSuccessToFalse(val)),
    getSegmentRulesCounts: (data, sid) => {
      dispatch(getSegmentRulesCounts(data, sid));
    },
    getSegmentTotalCounts: (data, sid) => {
      dispatch(getAudienceCount(data, sid));
    },
    requestActivation: (id, clientId, subject, comment) => {
      dispatch(requestActivation(id, clientId, subject, comment));
    },
  };
};

const SegmentDetail = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SegmentDetailIndex);

export default SegmentDetail;



// WEBPACK FOOTER //
// ./src/containers/NewSegmentDetail/Index.js